export class AppSettings {
    cookie: string = '';
    userName: string = '';
    password: string = '';
    environment: string = '';
    USE_DIRECT_API: boolean = false;
}